import PropTypes from 'prop-types';
import { propTypes as selectPropTypes, defaultProps as selectDefaultProps } from '../propTypes';

export const CLEAR_FILTER_TIMEOUT = 500;

export const propTypes = {
    ...selectPropTypes,
    toggleRef: PropTypes.ref(),
    role: PropTypes.string,
    openOnFocus: PropTypes.bool,
    openOnKeyDown: PropTypes.bool,
    closeWithTab: PropTypes.bool,
    toggleOnClick: PropTypes.bool,
    toggleWithSpace: PropTypes.bool,
    toggleWithEnter: PropTypes.bool,
    selectWithArrow: PropTypes.bool,
    selectWithChar: PropTypes.bool,
    selectWithSpace: PropTypes.bool,
    highlightWithChar: PropTypes.bool,
    highlightWithArrow: PropTypes.bool,
    ignoreNavigationKeys: PropTypes.bool,
    clearFilterTimeout: PropTypes.number,
    selectAllContentClassName: PropTypes.string,
};

export const defaultProps = {
    ...selectDefaultProps,
    toggleRef: null,
    role: null,
    openOnFocus: false,
    openOnKeyDown: false,
    closeWithTab: true,
    toggleOnClick: true,
    toggleWithSpace: true,
    toggleWithEnter: true,
    selectWithChar: true,
    selectWithArrow: true,
    selectWithSpace: true,
    highlightWithChar: true,
    highlightWithArrow: true,
    ignoreNavigationKeys: false,
    clearFilterTimeout: CLEAR_FILTER_TIMEOUT,
    selectAllContentClassName: null,
};
